<template>
  <div class="nav-item dropdown mr-1 ml-2">
    <div
      v-show="isAuthenticated"
      class="dropdown-toggle mr-1 ml-2"
      data-toggle="dropdown"
      id="dropdownMenu2"
    >
      <div v-show="isAuthenticated" class="dropdown mr-1 ml-2">
        <div class="numberCircle">{{ initials }}</div>
        <div v-if="!mobileView" class="k-user k-desktop">{{ userName }}</div>

        <div
          class="dropdown-menu dropdown-menu-right mt-2"
          aria-labelledby="dropdownMenu2"
        >
          <div
            v-if="auth"
            @click="onMyDashboard"
            class="dropdown-item"
            type="button"
          >
            {{ $t('profileDropDown.dashboard') }}
          </div>
          <div
            @click="onFeedback"
            class="dropdown-item"
            type="button"
          >
            {{ $t('profileDropDown.feedback') }}
          </div>

          <div
            v-if="1 || isAdmin"
            @click="onMembership"
            class="dropdown-item"
            type="button"
          >
            {{ $t('profileDropDown.membership') }}
          </div>

           <div
            v-if="isAdmin"
            @click="deleteSubscription"
            class="dropdown-item"
            type="button"
          >
            Delete Subscription
          </div>

          <div
            v-if="isAdmin"
            @click="onProjectLog"
            class="dropdown-item"
            type="button"
          >
            Projects Log
          </div>

          <div
            v-if="isAdmin"
            @click="onMarketingEmail"
            class="dropdown-item"
            type="button"
          >
            Marketing Email
          </div>

          <div
            v-if="isAdmin"
            @click="onTestView"
            class="dropdown-item"
            type="button"
          >
            Test
          </div>



          <div @click="onMyProfile" class="dropdown-item" type="button">
            {{ $t('profileDropDown.profile') }}
          </div>

          <div 
          v-if="isAdmin"
          @click="onParticipantAttributes" class="dropdown-item" type="button">
            Participant Attributed
          </div>


          <div v-if="0" @click="onHelp" class="dropdown-item" type="button">
            {{ $t('profileDropDown.help') }}
          </div>

          <template v-if="isAdmin">
            <hr/>
            <div @click="deleteAccount" class="dropdown-item" type="button">
              {{ $t('profileDropDown.deleteAccount') }}
            </div>
          </template>

          <div class="m-2">
            <button
              @click="onLogout"
              class="btn btn-primary btn-sm btn-block"
              type="button"
            >
              {{ $t('header.logout') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isAuthenticated" @click="onLogin" class="text-size-14 ml-1">
      {{ $t('header.login') }}
    </div>

    <component
      v-if="visibleDropdown"
      @close="onClose"
      :is="sidePanelDialog"
    ></component>

    <ModalDialog
        ref="dlgDeleteAccount"
        :title="$t('general.deleteAccountMsg')"
        :labelOk="$t('customBranding.okLabel')"
        :showCancelIcon="true"
        :displayCancelButton="false"
        @cancel="whenCancel()"
        :displayOkButton="false"
    >
        <div class="form-group display-content">
            <input-text-validated
                :label="$t('general.email')"
                type="text"
                id="modalEmail"
                rules=""
                v-model="userEmail"
            />

            <Btn
                @click.native="deleteAccountProcess()"
                :label="$t('general.delete')"
                class="mt-2"
                :disabled="userEmail.length == 0"
                :loading="loading"
            />
        </div>
    </ModalDialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import EditProfile from '@/components/Edit/EditProfile.vue';
import EditPassword from '@/components/Edit/EditPassword.vue';
import EditParticipantAttributes from '@/components/Edit/EditParticipantAttributes.vue';
import shared from '@/shared.js';
import { HTTP } from '@/shared/http';

export default {
  name: 'Navigation',

  data() {
    return {
      visibleDropdown: false,
      sidePanelDialog: 'edit-profile',
      languages: [
        { flag: 'us', language: 'us', title: 'English' },
        { flag: 'de', language: 'de', title: 'German' },
      ],
      loading: false,
      userEmail: ''
    };
  },

  props: {
    locale: String,
  },

  components: {
    EditProfile,
    EditPassword,
    EditParticipantAttributes
  },

  computed: {
    ...mapState(['visibleNav', 'mobileView']),

    auth() {
      return this.$store.getters.isAuthenticated;
    },

    initials() {
      if (!this.userName) {
        return ' ';
      }
      // join all the charcter after the space and took maximum 2 character
      return shared.getInitials(this.userName);
    },
    showLogin() {
      return this.isAuthenticated === false;
    },
    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      isAdmin: 'isAdmin',
      userName: 'userName'
    }),

    flag() {
      for (var i in this.languages) {
        if (this.languages[i].language === this.locale) {
          let flag = this.languages[i].flag;
          return flag;
        }
      }
      return '';
    },

    language() {
      for (var i in this.languages) {
        if (this.languages[i].language === this.locale) {
          let title = this.languages[i].title;
          return title;
        }
      }
      return '';
    },
  },

  methods: {
    ...mapActions([
      'replaceExistingUserDetails'
    ]),
    onBack() {
      if (this.isAuthenticated) {
        this.$router.push('/dashboard');
      } else {
        this.$router.push('/');
      }
    },

    changeLocale(locale) {
      console.log('Emit LOCALE event with value:' + locale);
      this.$emit('locale', locale);
    },

    onLogout() {
      this.$store.dispatch('logout');
    },

    onMyDashboard() {
      console.log('router push - dashboard');
      this.$router.push('/dashboard');
    },

    onMembership() {
      this.$router.push('/membership');
    },

    deleteSubscription() {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/delete-trial/' + this.userId;
      HTTP.delete(url)
      .then((response) => {
        console.log(response);
        this.replaceExistingUserDetails(response.data.user);
        this.$router.push(this.$route.path);
        this.$router.go();
      })
      .catch((error) => {
        console.log(error);
      });
    },

    onProjectLog() {

      const url = encodeURI('/api/log/projects');
      HTTP.get(url)
        .then((response) => {
          var fileLink = document.createElement('a');
          fileLink.href = response.data.path;
          fileLink.setAttribute('download', 'all-projects.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((error) => console.log(error));
    },      
    

    onMarketingEmail() {
      this.$router.push('/marketing-email')
    },      

    onTestView() {
      this.$router.push('/test-view')
    },      


    onFeedback() {

      const url = this.$t("profileDropDown.feedbackUrl")
      console.log("OnFeedback:", url);
      window.open(url, '_blank');
    },


    onMyProfile() {
      //this.$router.push('profile');
      this.visibleDropdown = true;
    },


    onParticipantAttributes() {
      console.log("onParticipantAttributes");
      this.sidePanelDialog = 'edit-participant-attributes';
      this.visibleDropdown = true;      
    },

    onClose(next) {
      this.visibleDropdown = false;
      if (!next) {
        this.sidePanelDialog = 'edit-profile';
        return;
      }

      this.sidePanelDialog = next;
      this.visibleDropdown = true;
    },

    onHelp() {
      window.open('http://kulibri.com/help', '_blank');
    },

    onLogin() {
      console.log('OnLogin:', this.$route.path);

      // check if the current url a project link is and if clear admin and public keys
      let redirectUrl = this.$route.path;
      if( redirectUrl ) {
        console.log("Login and redirect to specific project");
        const pathArray = redirectUrl.split('/');
        redirectUrl = '/pr/' + pathArray[2];

      }

      this.$router.push({
        path: '/signin?url=' + redirectUrl,
        redirect: redirectUrl,
        props: true,
      });
    },
    deleteAccount() {
      this.$refs.dlgDeleteAccount.openModal();
    },
    deleteAccountProcess() {
      this.loading = true;
      this.$store.dispatch('deleteUser', this.userEmail).then((response) => {
        this.loading = false;
        alert(response.message);
      });
    },
    whenCancel() {
      this.$refs.dlgDeleteAccount.closeModal();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/styles/colors.scss';


.dropdown-toggle::after {
  display: none;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.headline-items {
  display: flex;
  flex-direction: row;
}

.k-user-circle {
  display: inline-block;
  background: $secondary;
  border: 0px solid #0f1c3f;
  border-radius: 50%;
  box-shadow: 0.375em 0.375em 0 0 rgba(15, 28, 63, 0.125);
  height: 0.8em;
  width: 0.8em;

  top: 2px;
}

.k-user {

  margin-left: 5px;
  margin-top: 6px;
}

@media (min-width: 960px) {

.k-user {
  display: inline-block;
}

}



.dropdown-menu {
  border-radius: 2px;
  padding-top: 8px;
  padding-bottom: 8px;
  //box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  box-sizing: border-box;
  width: 240px;
  touch-action: manipulation;
}

.dropdown-item:hover {
  background-color: $very-light-grey;
}

.numberCircle {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding-left: 0px;
  padding-top: 8px;
  display: inline-block;
  background: $user-bubble;
  border: 0px solid;
  color: $dark-grey;
  text-align: center;
  font: 14px Arial, sans-serif;
  text-transform: uppercase;
}

hr {
  width: 70%;
  margin-top: 5px;
  margin-bottom: 5px;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
